import { useState } from 'react';
import cx from 'clsx';
import { Button } from '@kcd/design-system';

import { ShoebillImage } from '~/components/Image';
import { TrackClick } from '~/components/TrackEvent';
import { CAMPAIGN_ROUTER } from '~/constants/router';
import { CampaignInfo } from '~/domains/campaign/components/CampaignInfo';
import type { OAISchema } from '~/types/openapi';
import { openPageModal } from '~/utils/mobileApp';

import { HomeCampaignProductItem } from './HomeCampaignProductItem';

type Props = {
  campaign: OAISchema['CampaignFrontListItemResponse'];
  isToday: boolean;
};

export function CampaignHorizontalProductListTypeSection({
  campaign,
  isToday,
}: Props) {
  const [selectedProduct, setSelectedProduct] = useState(campaign.products![0]);

  return (
    <div
      className="flex flex-col gap-12 rounded-[24px] border border-solid border-02 py-16"
      role="presentation"
    >
      <div className="flex flex-col gap-12 px-20">
        <CampaignInfo campaign={campaign} isToday={isToday} />
        <TrackClick
          name="clicked product in 마켓"
          properties={{
            placementName: '마켓알뜰톡톡',
            detailedPlaceMent: campaign.code,
            campaignDate: campaign.exposureAtKst,
            path: window.location.pathname,
          }}
        >
          <HomeCampaignProductItem product={selectedProduct} />
        </TrackClick>
      </div>

      {Boolean(campaign.products!.length >= 2) && (
        <div
          className="flex gap-8 horizontal-scroll 
       [&>div:first-of-type]:ml-20 [&>div:last-of-type]:mr-20"
        >
          {campaign.products?.map((product) => {
            return (
              <TrackClick
                name="clicked button in 마켓"
                properties={{
                  placementName: '마켓알뜰톡톡',
                  detailedPlaceMent: campaign.code,
                  campaignDate: campaign.exposureAtKst,
                  path: window.location.pathname,
                  productName: product.productName,
                }}
              >
                <div
                  key={product.offerId}
                  onClick={() => setSelectedProduct(product)}
                  role="presentation"
                  className={cx(
                    'inline-block size-[60px] overflow-hidden shrink-0 scroll-mx-20 rounded-12 border border-solid border-02',
                    selectedProduct.offerId === product.offerId
                      ? 'border-primary-regular border-[2px]'
                      : 'border-02',
                  )}
                >
                  <ShoebillImage
                    width={60}
                    height={60}
                    className="object-contain"
                    src={product.mainImages![0]}
                  />
                </div>
              </TrackClick>
            );
          })}
        </div>
      )}
      <div className="px-20">
        <Button
          variant="outline"
          size="md"
          className="w-full"
          onClick={() => {
            openPageModal(CAMPAIGN_ROUTER.campaignDetail(campaign.code));
          }}
        >
          상품 보러가기
        </Button>
      </div>
    </div>
  );
}
